export const CONTRACT_ADDRESS = "0xB17b9165676bff0834Ef7E303Ed09144d5ed088f";

export const LOGO = "logo.png";